import { httpRequest } from "../../../utils/HttpRequest";
import { IDictDetail,IDictInsert,IDictUpdate,IDictSearch } from "./dictTypes";
import { IPage } from "@/types/AppTypes";

class DictService {
    async page(searchVo: IDictSearch) {
        const apiUrl = "/web/dict/search_page";
        return await httpRequest.post<IPage<IDictDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/dict/search_one/${id}`;
        return await httpRequest.get<IDictDetail>(apiUrl);
    }
    async insert(insertVo: IDictInsert) {
        const apiUrl = `/web/dict/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IDictUpdate) {
        const apiUrl = `/web/dict/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(id: string) {
        const apiUrl = `/web/dict/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async allTree(searchVo:IDictDetail){
        const apiUrl = "/web/dict/find_all_tree";
        return await httpRequest.post<IPage<IDictDetail>>(apiUrl, searchVo);
    }
}
export const dictService = new DictService();
